import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, ref, Ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  NavBar,
  HeadingDisplay,
  Row,
  StatusMessage,
  ToggleSwitch,
  ButtonIconContextual,
  ButtonBoxIcon,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import {
  BackButton,
  ShowMoneyToggleButton
} from '@/modules/common/components/buttons';
import { ConfirmEditModal } from './components/ConfirmEditModal';
import { Money } from '@/modules/common/components/Money';

import { IMarginAllocation } from '@/modules/trade/services/margin-allocation';
import { EMarginAllocationSteps } from '@/modules/trade/views/MarginAllocation/helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'DayTrade',
  setup(__props) {

const router = useRouter();

const updateDataForm = inject(
  'updateDataForm',
  (key: string, value: boolean) => ({
    key,
    value
  })
);
const changeStep = inject('changeStep', (step: EMarginAllocationSteps) => ({
  step
}));
const fetchUpdatePreference = inject(
  'fetchUpdatePreference',
  (value: boolean) => ({ value })
);
const marginAllocation = inject('marginAllocation') as Ref<IMarginAllocation>;
const dataForm = inject('dataForm') as Ref<{ isUpdatingPreferences: boolean }>;

const savePreference = ref(marginAllocation.value.isPreferencesSaved);
const isConfirmEditModalOpen = ref(false);
const confirmEditModalStep = ref(EMarginAllocationSteps.BALANCE);

const isTraderShieldEnabled = computed(() => {
  return marginAllocation.value.isTraderShieldEnabled;
});

const disableEditWithTraderShield = computed(() => {
  return (
    marginAllocation.value.allocationChangeCount > 0 &&
    isTraderShieldEnabled.value
  );
});

const canEditLimits = computed(() => {
  return (
    !disableEditWithTraderShield.value && marginAllocation.value.canEditMargin
  );
});

const hasPosition = computed(() => {
  return marginAllocation.value.hasPosition;
});

const details = computed(() => {
  return [
    {
      title: 'Saldo day trade',
      subtitle: marginAllocation.value.balance.formatted,
      step: EMarginAllocationSteps.BALANCE
    },
    {
      title: 'Prejuízo máximo',
      subtitle: marginAllocation.value.maximumDrawdown.formatted,
      step: EMarginAllocationSteps.DRAWDOWN
    }
  ];
});

const tradeShieldDetails = computed(() => {
  return isTraderShieldEnabled.value
    ? {
        title: 'Trader Shield ativo',
        description:
          'Para editar seus limites novamente, desative este recurso.',
        type: 'positive'
      }
    : {
        title: 'Ative o Trader Shield',
        description: 'Camada extra de proteção às suas operações',
        type: 'negative'
      };
});

const confirmEditModalData = computed(() => {
  return {
    updatedAt: marginAllocation.value.updatedAt,
    dayTradeBalance: marginAllocation.value.balance.formatted,
    variation: marginAllocation.value.variation
  };
});

function goToTraderShield() {
  changeStep(EMarginAllocationSteps.TRADER_SHIELD);
}

function editSingleLimit(step: EMarginAllocationSteps) {
  updateDataForm('isSingleEdit', true);

  if (marginAllocation.value.allocationChangeCount > 0) {
    isConfirmEditModalOpen.value = true;
    confirmEditModalStep.value = step;

    return;
  }

  changeStep(step);
}

function editLimits() {
  updateDataForm('isSingleEdit', false);

  if (marginAllocation.value.allocationChangeCount > 0) {
    isConfirmEditModalOpen.value = true;
    confirmEditModalStep.value = EMarginAllocationSteps.BALANCE;

    return;
  }
  changeStep(EMarginAllocationSteps.BALANCE);
}

function handlePreference() {
  fetchUpdatePreference(savePreference.value);
}

function handleBack() {
  router.push({ name: 'trade' });
}

return { __sfc: true,router, updateDataForm, changeStep, fetchUpdatePreference, marginAllocation, dataForm, savePreference, isConfirmEditModalOpen, confirmEditModalStep, isTraderShieldEnabled, disableEditWithTraderShield, canEditLimits, hasPosition, details, tradeShieldDetails, confirmEditModalData, goToTraderShield, editSingleLimit, editLimits, handlePreference, handleBack, NavBar, HeadingDisplay, Row, StatusMessage, ToggleSwitch, ButtonIconContextual, ButtonBoxIcon, ButtonContainer, ButtonPrimary, BackButton, ShowMoneyToggleButton, ConfirmEditModal, Money }
}

})